"use client";

import classNames from "classnames";

import { FacetKey, FacetOption } from "@/@types/filters";
import ColorSwatch from "./ColorSwatch";
import styles from "./Filters.module.scss";

interface Props {
  facetKey: FacetKey;
  option: FacetOption;
  selected: boolean;
  onToggle: (key: FacetKey, value: string) => void;
}

export default function FilterOption({ facetKey, option, selected, onToggle }: Props) {
  // Uma opção zerada continua na lista, mas desabilitada: some-la faria o
  // painel "pular" a cada clique.
  const disabled = option.count === 0 && !selected;

  return (
    <button
      type="button"
      className={classNames(styles.option, {
        [styles.optionSelected]: selected,
        [styles.optionDisabled]: disabled,
      })}
      aria-pressed={selected}
      disabled={disabled}
      onClick={() => onToggle(facetKey, option.value)}
    >
      {facetKey === "cor" && <ColorSwatch value={option.value} />}
      <span className={styles.optionLabel}>{option.label}</span>
      <span className={styles.optionCount}>{option.count}</span>
    </button>
  );
}
